import { ExternalLink, PartyPopper } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PublishedStep({
  title,
  onView,
  onAnother,
}: {
  title: string;
  onView: () => void;
  onAnother: () => void;
}) {
  return (
    <div className="flex flex-col items-center gap-4 py-8 text-center">
      <span className="grid size-14 place-items-center rounded-full bg-[image:var(--nymbl-gradient)] text-white">
        <PartyPopper className="size-7" />
      </span>
      <h2 className="font-display text-2xl font-bold text-fg-1">"{title}" is live</h2>
      <p className="max-w-md text-fg-2">
        The scan came back clean and your skill is published. It's searchable across the library
        now, with download and view counters initialized.
      </p>
      <div className="flex gap-3">
        <Button onClick={onView}>
          <ExternalLink className="size-4" />
          View skill page
        </Button>
        <Button variant="outline" onClick={onAnother}>
          Submit another
        </Button>
      </div>
    </div>
  );
}
